import { render, staticRenderFns } from "./projectUsers.vue?vue&type=template&id=b78d5af0&"
import script from "./projectUsers.vue?vue&type=script&lang=js&"
export * from "./projectUsers.vue?vue&type=script&lang=js&"
import style0 from "./projectUsers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports